<template>

    <cms-view v-spinner="loading" :hide="loading">
        <cms-heading :title="pageTitle"></cms-heading>

        <cms-form-panel submit-button="Opslaan" :cancel-button="true" :submitting="submitting" @submit="submit">

            <cms-form-input title="Referentie" name="reference" v-model.trim="pendingRepair.reference"
                            v-validate="'required'" data-vv-as="Referentie" :error="error('reference')"></cms-form-input>

            <cms-form-date-picker title="Einddatum" name="endDate" v-model.trim="pendingRepair.endDate" input="true" :options="{ disableMobile: true }"
                            v-validate="'required'" data-vv-as="Einddatum" :error="error('endDate')"></cms-form-date-picker>

        </cms-form-panel>
    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag';

    import pick from 'lodash/pick'
    import clone from 'lodash/clone'

    import RepairQueries from 'app/queries/RepairQueries'
    import RepairMutations from 'app/mutations/RepairMutations'

    @Component({

        name: 'repair-form',
        apollo: {

            repair: RepairQueries.find({

                skip(){
                    return !this.$route.params.id;
                },

                result(result){

                    if(result && result.data) {
                        this.pendingRepair = pick(result.data.viewer.findRepair, ['reference', 'endDate']);
                    }
                },

                variables(){

                    return {
                        repairId: this.itemId,
                    }
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                repair: null,
                pendingRepair: {
                    reference: null,
                    endDate: null
                },

                submitting: false,
                submitted: false,

                loading: 0
            }
        }

        breadcrumb(){

            return [{
                title: 'Reparaties',
                route: {
                    name: 'repairs'
                }
            }, this.pageTitle];
        }

        created(){

            this.logger = this.$logger.child('RepairForm');
        }

        get pageTitle(){

            return this.repair ? this.repair.reference + ' wijzigen' : '';
        }

        get itemId(){

            return this.$route.params.id;
        }

        onQueryError(){

            this.$toast.error('De reparatie kon niet worden opgehaald');
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                this.submitting = true;
                var repairData = clone(this.pendingRepair);
                repairData.id = this.repair.id;

                RepairMutations.update(repairData).then(() => {

                    this.logger.info('Repair updated');
                    this.$toast.success('De reparatie is opgeslagen');

                    this.submitting = false;

                    this.$router.push({
                        name: 'repair-view',
                        params: { id: this.repair.id }
                    });

                }).catch(e => this.handleSubmitError(e));
            });
        }

        handleSubmitError(e){

            this.logger.error('Error saving repair', e);
            this.$toast.error('De reparatie kon niet worden opgeslagen');

            this.submitting = false;
        }
    }

</script>